<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>نام پکیج</th>
                    <th>وضعیت</th>
                    <th>دیفالت</th>
                    <th>جزییات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="chat in chats" :key="chat._id">
                    <td>{{ chat.packageTitle }}</td>
                    <td>{{ chat.isAvailable ? 'فعال' : 'غیر فعال' }}</td>
                    <td>{{ chat.isDefault ? 'اصلی' : 'فرعی' }}</td>
                    <td>
                      <router-link :to="{ path: '/dashboard/chat', query: { id: chat._id } }">مشاهده</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chatService from '../../../../services/chat';
export default {
  name: 'chats',
  data() {
    return {
      chats: [],
    };
  },
  created() {
    this.getchats();
  },
  methods: {
    async getchats() {
      try {
        const condition = {};
        const resData = await chatService.getAllChats(condition);
        console.log(resData);
        this.chats = resData;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
